export default {
  newDesign: true,
  title: "Dapatkan pelajaran matematika gratis yang disesuaikan untuk anak Anda! | Kodland",
  downtimeUrl: "https://id6.kodland.tech",
  parameters: {
    landing_id: "IdMathLGcc",
    segment: 4,
    fb_pixel: 1113125277872242,
  },
  startPage: {
    title:
      "Jawab 4 pertanyaan singkat berikut dan dapatkan pelajaran matematika gratis!",
    button: " Ayo Mulai! 🚀 ",
    image: {
      url: "/welcome/math_freetc_indonesia2_desk.png",
      style: {
        height: "100%",
        "max-height": "100vh",
      },
    },
    imageMobile: {
      url: "/welcome/math_freetc_indonesia2_mob.png",
      style: {
        width: "100%",
      },
    },
  },
  stopPage: {
    image: "/welcome/quizV2/no-computer.png",
    title: "Terima kasih atas kepercayaan Anda pada platform pendidikan kami!",
    subtitle:
      "Sayangnya, tablet atau ponsel tidak sesuai untuk mengikuti pelajaran kami. Kami akan sangat senang melihat Anda di kelas berikutnya!",
  },
  quizRotateBySteps: {
    1: {
      question: "Bagaimana perasaan anak Anda terhadap matematika?",
      answers: [
        "😍 Mereka sangat suka!",
        "🙂 Butuh sedikit dorongan",
        "😕 Kesulitan dan menghindar",
        "🤔 Kurang suka, tapi saya ingin mengubahnya",
      ],
    },
    2: {
      question:
        "Apa prioritas utama Anda saat anak belajar matematika?",
      answers: [
        "🤩 Membuat mereka tertarik",
        "👨‍💻 Menunjukkan pentingnya matematika dalam kehidupan",
        "🏫 Mendorong prestasi di sekolah",
        "🚀 Mengubah cara belajar yang membosankan",
      ],
    },
    3: {
      typeInfo: "noQuestions",
      imageLink: "/welcome/reviews_ind2.png",
      subtitle: "Kami siap membantu anak Anda mencintai Matematika. Lebih dari 100.000 orang tua telah mempercayakan kami untuk membangkitkan minat dan prestasi anak dalam matematika.",
      button: "Keren! 🔥",
    },
    4: {
      question:
        "Apakah penting bagi Anda agar anak mendapat semua pengetahuan akademis?",
      answers: [
        "📏 Sangat penting!",
        "🖌️ Penting, tapi kreativitas juga penting",
        "😃 Saya ingin mereka menikmati belajar, bukan hanya nilai",
        "🤔 Saya ingin mereka siap menghadapi masa depan",
      ],
    },
    5: {
      question:
        "Apa yang paling disukai anak Anda saat belajar?",
      answers: [
        "🕹️ Metode belajar sambil bermain",
        "📋 Penjelasan langkah-demi-langkah",
        "👥 Belajar di kelompok kecil",
        "👨‍🏫 Tutor yang menginspirasi",
        "🙌 Semua di atas",
      ],
    },
    6: {
      typeInfo: "noQuestions",
      imageLink: "/welcome/kid_ind2.png",
      subtitle: "Tutor kami yang ramah dan sabar membuat matematika menyenangkan dan mudah dipahami. Mereka akan mengajar sesuai ritme anak Anda.",
      button: "Pilih waktu pelajaran 🕒",
    },
    7: {
      title: "Pilih usia anak",
      type: "age",
      subtitle:
        "Pengajar profesional kami akan membantu kamu dan anak mendalami profesi IT",
      button: "",
    },
    8: {
      question:
        "Untuk mengikuti kelas gratis ini, Anda perlu menggunakan komputer atau laptop (bukan HP) dengan koneksi internet stabil. Apakah Anda memiliki komputer/laptop di rumah?",
      answers: [
        "💻 Ya, kami memiliki komputer/laptop di rumah",
        {
          answer: "❌ Tidak, kami tidak memiliki komputer/laptop di rumah",
          stopAnswer: true,
        },
      ],
    },
    9: {
      title: "Pilih tanggal dan waktu untuk mendapatkan pelajaran GRATIS",
      typeInfo: "congrats",
      subtitle:
        "Klik tombol '📆 Pesan' dan dapatkan pelajarannya",
      button: "📆 Pesan",
    },
    10: {
      title: "Dapatkan kelas uji coba gratis",
      type: "one-page-contacts",
      subtitle: "",
      button: "Lanjutkan 🔥",
    },
    11: {
      title: "",
      type: "timeslot",
      subtitle: "",
      button: "",
    },
    12: {
      title: "Tinjau detail berikut untuk menyelesaikan pendaftaran ✨",
      typeInfo: "pc-laptop",
      subtitle:
        "Harap diperhatikan bahwa Anda akan membutuhkan komputer atau laptop yang berfungsi untuk pelajaran, dan Anda harus menemani anak Anda selama kelas berlangsung. Mohon diingat bahwa pelajaran ini bersifat individual dan personal.",
      button: "Selanjutnya bagaimana?",
    },
    13: {
      title: "Sebelum kelas uji coba, periksa email dan WhatsApp Anda  📞",
      typeInfo: "whatsapp",
      subtitle:
        "Kami akan mengirimkan pengingat 24 jam sebelum kelas dimulai dan meminta Anda untuk mengonfirmasikan kehadiran Anda 2 jam sebelum kelas dimulai. Sangat penting untuk tetap berkomunikasi agar kelas tidak dibatalkan.",
      button: "Selanjutnya bagaimana?",
    },
    14: {
      title: "Kelas akan diadakan di platform kami 💻",
      typeInfo: "classroom",
      subtitle:
        "Anda akan menerima tautan dan kode unik melalui WhatsApp dan email. Klik saja tautannya, dan Anda akan langsung diarahkan ke kelas. Tidak perlu aplikasi tambahan, tidak perlu mengunduh apa pun.",
      button: "Mengerti ✅",
    },
  },
};
